"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotionModePage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const MotionsCarousel_1 = require("../../organisms/MotionsCarousel");
const MotionsTab_1 = __importDefault(require("../../organisms/MotionsTab"));
const motion_panel_1 = require("@completeanatomy/motion-panel");
const templates_1 = require("../../templates");
const bridge_1 = require("@completeanatomy/bridge");
const device_1 = require("@completeanatomy/device");
const hooks_1 = require("../../hooks");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const models_1 = require("@completeanatomy/models");
function MotionModePage() {
    const selectedPart = (0, models_1.useSelectedPart)();
    const bridge = (0, bridge_1.useBridge)();
    const { isMobile } = (0, device_1.usePlatform)();
    (0, hooks_1.useSelectInfoBoxTab)(bridge_schema_1.InfoBoxTabType.Motion);
    const handleBack = () => bridge === null || bridge === void 0 ? void 0 : bridge.exitModelAnimationMode();
    return ((0, jsx_runtime_1.jsxs)(templates_1.ModeTemplate, { title: selectedPart.name, onBack: handleBack, mode: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.mode, {
            mode: i18n_1.Strings.infoBox.tabs['motion'],
        }), shouldShowModelLoading: true, "data-e2e": 'MotionModePage_ModeTemplate', children: [(0, jsx_runtime_1.jsx)(StyledMotionPanel, { isMobile: isMobile, "data-e2e": 'MotionModePage_StyledMotionPanel' }), !isMobile ? (0, jsx_runtime_1.jsx)(MotionsTab_1.default, { isFull: true, "data-e2e": 'MotionModePage_MotionsTab' }) : (0, jsx_runtime_1.jsx)(MotionsCarousel_1.MotionsCarousel, { "data-e2e": 'MotionModePage_MotionsCarousel' })] }));
}
exports.MotionModePage = MotionModePage;
const StyledMotionPanel = (0, styled_components_1.default)(motion_panel_1.MotionPanel) `
  position: absolute;

  ${({ isMobile }) => !isMobile
    ? (0, styled_components_1.css) `
          right: 0;
          bottom: 0;
        `
    : (0, styled_components_1.css) `
          top: 0;
          left: 0;

          transform: translateY(-100%);
        `}
`;
